import { render } from "./WifiOverlay.vue?vue&type=template&id=4dec15c6&scoped=true"
import script from "./WifiOverlay.vue?vue&type=script&lang=js"
export * from "./WifiOverlay.vue?vue&type=script&lang=js"

import "./WifiOverlay.vue?vue&type=style&index=0&id=4dec15c6&scoped=true&lang=css"

import exportComponent from "/home/cherry/safer_pet/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dec15c6"]])

export default __exports__